<div class="search">
    <fa-icon icon="search" class="search-icon"></fa-icon>
    <input 
        #searchInput   
        type="search" 
        [class]="expandOnFocus ? 'search-input search-input-animated' : 'search-input'" 
        placeholder="Søg..."
        (input)="onSearch(searchInput.value)">
</div>